export default "__VITE_ASSET__DBqQrBW___"